<template>
  <v-data-table :headers="headers" :items="localInventories" class="elevation-1" :items-per-page="-1" mobile-breakpoint="1024" disable-sort>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>在庫一覧</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialogAdd" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">在庫登録</v-btn>
          </template>
          <v-form ref="formAdd">
            <v-card>
              <v-card-title>
                <span class="text-h5">在庫登録</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.location" :items="localLocations" label="保管場所" item-text="name" item-value="id" return-object></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedInventory.item.category.name" label="カテゴリ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.item" :items="localItems" label="品目名" :rules="[rules.requiredItemName]" item-text="name" item-value="id" return-object></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.expirationDateManagement">
                      <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="editedInventory.expirationDate" label="有効期限" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="editedInventory.expirationDate" @input="menu = false" full-width></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedInventory.remainingQty" label="在庫数量" type="number" min="1" :rules="[rules.positiveNonZeroInt]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.unitPurchasePriceManagement">
                      <v-text-field v-model.number="editedInventory.unitPurchasePrice" label="購入単価" type="number" min="0" :rules="[rules.positiveInt]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.unitPurchasePriceManagement">
                      <v-text-field v-model="editedInventory.store" label="購入店"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeAdd">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localAddInventory">登録</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogDelete" persistent>
          <v-form>
            <v-card>
              <v-card-title>
                <span class="text-h5">この在庫を削除してよろしいですか？</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.location" :items="localLocations" label="保管場所" item-text="name" item-value="id" return-object disabled></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedInventory.item.category.name" label="カテゴリ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.item" :items="localItems" label="品目名" item-text="name" item-value="id" return-object disabled></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.expirationDateManagement">
                      <v-text-field v-model="editedInventory.expirationDate" label="有効期限" prepend-icon="mdi-calendar" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedInventory.remainingQty" label="在庫数量" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.unitPurchasePriceManagement">
                      <v-text-field v-model.number="editedInventory.unitPurchasePrice" label="購入単価" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.unitPurchasePriceManagement">
                      <v-text-field v-model="editedInventory.store" label="購入店" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localDeleteInventory">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogPlus" persistent>
          <v-form ref="formPlus">
            <v-card>
              <v-card-title>
                <span class="text-h5">在庫を補充しますか？ 在庫を補充する場合は、補充数量を入力して補充登録をクリックしてください。</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.location" :items="localLocations" label="保管場所" item-text="name" item-value="id" return-object disabled></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedInventory.item.category.name" label="カテゴリ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.item" :items="localItems" label="品目名" item-text="name" item-value="id" return-object disabled></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.expirationDateManagement">
                      <v-text-field v-model="editedInventory.expirationDate" label="有効期限" prepend-icon="mdi-calendar" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedInventory.remainingQty" label="在庫数量" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedInventory.additionalQty" label="補充数量" type="number" min="0" :rules="[rules.positiveNonZeroInt]"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closePlus">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localPlusInventory">補充登録</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogMinus" persistent>
          <v-form>
            <v-card>
              <v-card-title>
                <span class="text-h5">在庫を1つ消費してよろしいですか？</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.location" :items="localLocations" label="保管場所" item-text="name" item-value="id" return-object disabled></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedInventory.item.category.name" label="カテゴリ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedInventory.item" :items="localItems" label="品目名" item-text="name" item-value="id" return-object disabled></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.expirationDateManagement">
                      <v-text-field v-model="editedInventory.expirationDate" label="有効期限" prepend-icon="mdi-calendar" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedInventory.remainingQty" label="在庫数量" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.unitPurchasePriceManagement">
                      <v-text-field v-model.number="editedInventory.unitPurchasePrice" label="購入単価" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedInventory.item.unitPurchasePriceManagement">
                      <v-text-field v-model="editedInventory.store" label="購入店" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeMinus">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localMinusInventory">消費登録</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogDonePlus" max-width="500px" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">在庫を補充しました。</span>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="blue darken-1" text @click="dialogDonePlus = false"> 閉じる </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDoneMinus" max-width="500px" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">在庫を1つ消費しました。</span>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="blue darken-1" text @click="dialogDoneMinus = false"> 閉じる </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.item.category.name`]="{ item }">
      <v-chip :color="getColor(item.item.category.color)" dark>
        {{ item.item.category.name }}
      </v-chip>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-icon @click="openPlus(item)"> mdi-plus-box </v-icon>
    </template>
    <template v-slot:[`item.action2`]="{ item }">
      <v-icon @click="openMinus(item)"> mdi-minus-box </v-icon>
    </template>
    <template v-slot:[`item.action3`]="{ item }">
      <v-icon @click="openDelete(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialogAdd: false,
      dialogDelete: false,
      dialogPlus: false,
      dialogMinus: false,
      dialogDonePlus: false,
      dialogDoneMinus: false,
      menu: false,
      headers: [
        { text: "登録日", value: "entryDate", align: "center" },
        { text: "保管場所", value: "location.name" },
        { text: "カテゴリ", value: "item.category.name" },
        { text: "品目名", value: "item.name" },
        { text: "有効期限", value: "expirationDate", align: "center" },
        { text: "在庫数量", value: "remainingQty", align: "end" },
        { text: "購入単価", value: "unitPurchasePrice", align: "end" },
        { text: "購入店", value: "store" },
        { text: "在庫を補充", value: "action", align: "center" },
        { text: "在庫を1つ消費", value: "action2", align: "center" },
        { text: "削除", value: "action3", align: "center" },
      ],
      localLocations: [],
      localItems: [],
      localInventories: [],
      editedInventory: {
        id: "",
        entryDate: "",
        item: {
          id: "",
          category: { id: "", name: "", color: "" },
          name: "",
          expirationDateManagement: false,
          unitPurchasePriceManagement: false,
        },
        location: {
          id: "",
          name: "",
        },
        expirationDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        unitPurchasePrice: 0,
        store: "",
        remainingQty: 0,
        additionalQty: 0,
      },
      defaultInventory: {
        id: "",
        entryDate: "",
        item: {
          id: "",
          category: { id: "", name: "", color: "" },
          name: "",
          expirationDateManagement: false,
          unitPurchasePriceManagement: false,
        },
        location: {
          id: "",
          name: "",
        },
        expirationDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        unitPurchasePrice: 0,
        store: "",
        remainingQty: 0,
        additionalQty: 0,
      },
      rules: {
        requiredItemName: (value) => !!value.name || "入力必須です。",
        required: (value) => !!value || "入力必須です。",
        positiveInt: (value) => {
          const pattern = /^([1-9]\d*|0)$/;
          return pattern.test(value) || "整数を入力ください。";
        },
        positiveNonZeroInt: (value) => {
          const pattern = /^([1-9]\d*)$/;
          return pattern.test(value) || "正の整数を入力ください。";
        },
        negativeNonZeroInt: (value) => {
          const pattern = /^(-[1-9]\d*)$/;
          return pattern.test(value) || "負の整数を入力ください。";
        },
      },
    };
  },
  created() {
    this.localLocations = this.$store.state.locations;
    this.localItems = this.$store.state.items;
    this.localInventories = this.$store.state.inventories;
  },
  watch: {
    dialogAdd(val) {
      val || this.closeAdd();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogPlus(val) {
      val || this.closePlus();
    },
    dialogMinus(val) {
      val || this.closeMinus();
    },
  },
  methods: {
    getColor(color) {
      switch (color) {
        case "青":
          return "blue";
        case "緑":
          return "green";
        case "橙":
          return "orange";
        case "灰":
          return "grey";
        case "黒":
          return "black";
        case "":
          return "transparent";
      }
    },
    openDelete(item) {
      this.editedInventory = Object.assign({}, item);
      this.dialogDelete = true;
    },
    openPlus(item) {
      this.editedInventory = Object.assign({}, item);
      this.dialogPlus = true;
    },
    openMinus(item) {
      if (item.remainingQty === 0) {
        alert("在庫がありません。");
      } else {
        this.editedInventory = Object.assign({}, item);
        this.dialogMinus = true;
      }
    },
    closeAdd() {
      this.$refs.formAdd.resetValidation();
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.editedInventory = Object.assign({}, this.defaultInventory);
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedInventory = Object.assign({}, this.defaultInventory);
      });
    },
    closePlus() {
      this.$refs.formPlus.resetValidation();
      this.dialogPlus = false;
      this.$nextTick(() => {
        this.editedInventory = Object.assign({}, this.defaultInventory);
      });
    },
    closeMinus() {
      this.dialogMinus = false;
      this.$nextTick(() => {
        this.editedInventory = Object.assign({}, this.defaultInventory);
      });
    },
    localAddInventory() {
      if (this.$refs.formAdd.validate()) {
        this.editedInventory.entryDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        if (!this.editedInventory.item.expirationDateManagement) {
          this.editedInventory.expirationDate = "";
        }
        if (!this.editedInventory.item.unitPurchasePriceManagement) {
          this.editedInventory.unitPurchasePrice = "";
          this.editedInventory.store = "";
        }
        this.addInventoryAndHistory(this.editedInventory);
        this.closeAdd();
      }
    },
    localDeleteInventory() {
      this.deleteInventoryAndHistory(this.editedInventory.id);
      this.closeDelete();
    },
    localPlusInventory() {
      if (this.$refs.formPlus.validate()) {
        this.editedInventory.remainingQty += this.editedInventory.additionalQty;
        this.plusMinusInventoryAndHistory(this.editedInventory);
        this.closePlus();
        this.dialogDonePlus = true;
      }
    },
    localMinusInventory() {
      this.editedInventory.additionalQty = -1;
      this.editedInventory.remainingQty -= 1;
      this.plusMinusInventoryAndHistory(this.editedInventory);
      this.closeMinus();
      this.dialogDoneMinus = true;
    },
    ...mapActions(["addInventoryAndHistory", "deleteInventoryAndHistory", "plusMinusInventoryAndHistory"]),
  },
};
</script>

<style></style>
